import { ReactNode, createContext } from "react";
import useTipoContaPagar, { TipoContaPagarType, CreateTipoContaPagarType, UpdateTipoContaPagarType } from "./hooks/useTipoContaPagar";

interface TipoContaPagarContextProviderProps {
    children: ReactNode;
}

export interface TipoContaPagarContextData {
    getAllTipoContaPagarPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<TipoContaPagarType[] | null>;
    setTipoContaPagar: any;
    tipoContaPagar: TipoContaPagarType;
    setListTipoContaPagar: any;
    listTipoContaPagar: TipoContaPagarType[];
    setInitialListTipoContaPagar: any;
    initialListTipoContaPagar: TipoContaPagarType[];
    setTipoContaPagarPageCount: any;
    tipoContaPagarPageCount: number;
    createTipoContaPagar: (createTipoContaPagarType: CreateTipoContaPagarType) => Promise<CreateTipoContaPagarType | null>;
    updateTipoContaPagar: (updateTipoContaPagarType: UpdateTipoContaPagarType) => Promise<UpdateTipoContaPagarType | null>;
    deleteTipoContaPagar: (id: number) => Promise<TipoContaPagarType | null>;
    handleGetTipoContaPagarByEmpresaId: (empresaId: number) => Promise<TipoContaPagarType[] | null>;
    listTipoContaPagarByEmpresa: TipoContaPagarType[];
    setListTipoContaPagarByEmpresa: any;
}

const initialState: TipoContaPagarContextData = {
    getAllTipoContaPagarPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setTipoContaPagar: () => { },
    tipoContaPagar: {
        id: 0,
        name: "",
        empresaId: 0,
    },
    setListTipoContaPagar: () => {},
    listTipoContaPagar: [],
    setInitialListTipoContaPagar: () => {},
    initialListTipoContaPagar: [],
    setTipoContaPagarPageCount: () => {},
    tipoContaPagarPageCount: 0,
    createTipoContaPagar: async (createTipoContaPagarType: CreateTipoContaPagarType) => {
        return Promise.resolve(null);
    },
    updateTipoContaPagar: async (updateTipoContaPagarType: UpdateTipoContaPagarType) => {
        return Promise.resolve(null);
    },
    deleteTipoContaPagar: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetTipoContaPagarByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listTipoContaPagarByEmpresa: [],
    setListTipoContaPagarByEmpresa: () => {},
};

export const TipoContaPagarContext =
    createContext<TipoContaPagarContextData>(initialState);

export default function TipoContaPagarContextProvider({
    children,
}: TipoContaPagarContextProviderProps) {
    const {
        getAllTipoContaPagarPaged,
        createTipoContaPagar,
        updateTipoContaPagar,
        deleteTipoContaPagar,
        tipoContaPagar,
        setTipoContaPagar,
        setListTipoContaPagar,
        listTipoContaPagar,
        initialListTipoContaPagar,
        setInitialListTipoContaPagar,
        setTipoContaPagarPageCount,
        tipoContaPagarPageCount,
        handleGetTipoContaPagarByEmpresaId,
        listTipoContaPagarByEmpresa,
        setListTipoContaPagarByEmpresa,
    } = useTipoContaPagar();

    return (
        <TipoContaPagarContext.Provider
            value={{
                getAllTipoContaPagarPaged,
                createTipoContaPagar,
                updateTipoContaPagar,
                deleteTipoContaPagar,
                tipoContaPagar,
                setTipoContaPagar,
                setListTipoContaPagar,
                listTipoContaPagar,
                initialListTipoContaPagar,
                setInitialListTipoContaPagar,
                setTipoContaPagarPageCount,
                tipoContaPagarPageCount,
                handleGetTipoContaPagarByEmpresaId,
                listTipoContaPagarByEmpresa,
                setListTipoContaPagarByEmpresa,
            }}
        >
            {children}
        </TipoContaPagarContext.Provider>
    );
}